import { API_BASE_URL } from "../../../config";
import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const API_BASE = `${API_BASE_URL}/seller/api/product-items`;

const CreateItemType = () => {
    const [productCode, setProductCode] = useState('');
    const [productName, setProductName] = useState('');
    const [description, setDescription] = useState('');
    const [active, setActive] = useState(true);

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Function to handle form submission
    const handleSubmit = useCallback(async (event) => {
        event.preventDefault();

        // Basic validations
        if (!productCode.trim()) {
            setError('Product code is required');
            return;
        }
        if (!productName.trim()) {
            setError('Product name is required');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).token : null;
            if (!token) {
                navigate('/login');
                return;
            }

            const response = await fetch(API_BASE, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ productCode, productName, description, active }),
            });

            if (!response.ok) {
                if (response.status === 403) {
                    navigate('/login');
                    return;
                }
                const txt = await response.text();
                throw new Error(txt || 'Failed to create product item');
            }

            const result = await response.json();
            console.log('Create response:', result); // Debugging line
            navigate('/salepriceAndItemManage'); // Redirect to combined management page on success
        } catch (error) {
            setError(error.message || 'Error creating product item');
            console.error('Create error:', error);
        } finally {
            setLoading(false);
        }
    }, [productCode, productName, description, active, navigate]);

    return (
        <div className="container">
            <h1>หน้าต่างสร้างสินค้า</h1>
            <button onClick={() => navigate('/salepriceAndItemManage')} className="backButton">
                กลับ
            </button>
            <br/>
            <br/>
            <form onSubmit={handleSubmit}>
                <div className="formGroup">
                    <label htmlFor="productCode">รหัสสินค้า (Product Code):</label>
                    <input
                        type="text"
                        id="productCode"
                        value={productCode}
                        onChange={(e) => setProductCode(e.target.value)}
                    />
                </div>
                <div className="formGroup">
                    <label htmlFor="productName">ชื่อสินค้า (Product Name):</label>
                    <input
                        type="text"
                        id="productName"
                        value={productName}
                        onChange={(e) => setProductName(e.target.value)}
                    />
                </div>
                <div className="formGroup">
                    <label htmlFor="description">รายละเอียด (Description):</label>
                    <input
                        type="text"
                        id="description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </div>
                <div className="formGroup">
                    <label htmlFor="active">สถานะการขาย (Active):</label>
                    <select id="active" value={active ? 'true' : 'false'} onChange={(e) => setActive(e.target.value === 'true')}>
                        <option value="true">ขาย</option>
                        <option value="false">ไม่ขาย</option>
                    </select>
                </div>
                <br/>
                {error && <p className="error">{error}</p>}
                <button type="submit" disabled={loading}>
                    {loading ? 'กำลังบันทึก...' : 'บันทึก'}
                </button>
            </form>
        </div>
    );
};

export default CreateItemType;
